import {
  CascadiaJsonFormContext,
  CascadiaLayoutProps,
  withCascadiaLayoutProps,
} from "@certn/forms";
import { RenderError } from "@certn/forms/src/components/helpers/RenderError";
import { BaseLayout } from "@certn/forms/src/layouts/BaseLayout";
import { BaseLayoutContent } from "@certn/forms/src/layouts/BaseLayoutContent";
import { hasLabel } from "@certn/forms/src/utils";
import { css } from "@emotion/css";
import { isBooleanControl, rankWith } from "@jsonforms/core";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { useApplication } from "../ApplicationContext";
import { GeneralAuthorizationControlRenderer } from "../controls/consent-control/GeneralAuthorizationControl";
import { isQuickscreenBasePath } from "../utils";
import { GeneralAuthorizationLayoutContext } from "./GeneralAuthorizationLayoutContext";
import { QuickscreenGeneralAuthorizationLayout } from "./QuickscreenGeneralAuthorizationLayout";

function GeneralAuthorizationLayout(props: CascadiaLayoutProps) {
  const { t } = useTranslation();
  const { isSummary } = useContext(CascadiaJsonFormContext);
  const { basePath } = useApplication();

  if (isSummary) {
    return null;
  }

  if (isQuickscreenBasePath(basePath)) {
    return <QuickscreenGeneralAuthorizationLayout {...props} />;
  }

  const { uischema } = props;
  const options = uischema.options || {};

  if (!hasLabel(uischema)) {
    return <RenderError>{t("Invalid Category")}</RenderError>;
  }

  return (
    <BaseLayout {...props} className={styles.layout}>
      <GeneralAuthorizationLayoutContext.Provider
        value={{ label: uischema.label, subLabel: options.subLabel }}
      >
        <BaseLayoutContent
          renderers={[
            {
              tester: rankWith(1, isBooleanControl),
              renderer: GeneralAuthorizationControlRenderer,
            },
          ]}
        />
      </GeneralAuthorizationLayoutContext.Provider>
    </BaseLayout>
  );
}

const styles = {
  layout: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
};

GeneralAuthorizationLayout.displayName = "GeneralAuthorizationLayout";

export const GeneralAuthorizationLayoutRenderer = withCascadiaLayoutProps(
  GeneralAuthorizationLayout
);
